import * as yup from "yup";

export const addDealerSchema = yup.object({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  dealerName: yup.string().required("Dealer name is required"),
  email: yup
    .string()
    .required("Email is required")
    .min(5, "Email must be at least 5 characters long")
    .email("Email is invalid"),
  country: yup.string().required("Country is required"),
  password: yup
    .string()
    .required("Password is required")
    .min(7, "Password must be at least 7 characters"),
  confirmPassword: yup
    .string()
    .required("Please confirm your password")
    .oneOf([yup.ref("password")], "Passwords do not match"),
});

export type AddDealerFormData = yup.InferType<typeof addDealerSchema>;

export const addDealerDefaultValues: AddDealerFormData = {
  firstName: "",
  lastName: "",
  dealerName: "",
  email: "",
  country: "",
  password: "",
  confirmPassword: "",
};

export const dealerCountries = [
  { label: "Australia", value: "AU" },
  { label: "United Kingdom", value: "UK" },
  { label: "Germany", value: "DE" },
  { label: "France", value: "FR" },
  { label: "New Zealand", value: "NZ" },
  { label: "Spain", value: "ES" },
  { label: "Italy", value: "IT" },
  { label: "Netherlands", value: "NL" },
  { label: "Sweden", value: "SE" },
  { label: "Norway", value: "NO" },
  { label: "Denmark", value: "DK" },
  { label: "Finland", value: "FI" },
  { label: "Belgium", value: "BE" },
  { label: "Portugal", value: "PT" },
  { label: "Croatia", value: "HR" },
  { label: "Greece", value: "GR" },
  { label: "Hungary", value: "HU" },
  { label: "Cyprus", value: "CY" },
].sort((a, b) => a.label.localeCompare(b.label));
